export default __webpack_public_path__ + "static/media/CreditsIcon.7514f6e2.png";